import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toLocalePipe',
})
export class ToLocalePipe implements PipeTransform {
  private readonly decimSeparator: string;
  private readonly thousSeparator: string;

  constructor() {
    this.decimSeparator = '.';
    this.thousSeparator = ',';
  }

  transform(elem: any) {
    let [integer, fraction = ''] = (elem.value || '').toString().split(this.decimSeparator);
    const measure: string = elem ? elem.getAttribute('data-char') : '';
    const measureAlign: string = elem ? elem.getAttribute('data-char-align') : '';
    let resp = '';

    integer = integer.replace(/[^0-9]/g, '');
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousSeparator);
    fraction = fraction.length ? this.decimSeparator + fraction.replace(/[^0-9]/g, '') : '';
    integer = integer.length ? integer : fraction.length ? '0' : '';
    resp = integer + fraction;

    return !resp.length
      ? ''
      : measureAlign === 'left'
      ? measure + resp
      : measureAlign === 'right'
      ? integer + fraction + measure
      : integer + fraction;
  }

  parse(elem: any) {
    let [integer, fraction = ''] = (elem.value || '').split(this.decimSeparator);
    integer = integer.replace(new RegExp(this.thousSeparator, 'g'), '').replace(/[^0-9]/g, '');
    return integer + fraction;
  }
}
